import api from "./api";

// GET /job-task-skills?job_id=<id>&task_id=<id>
// Compares a task's required skills against the skills a job already has.
// Response shape:
// {
//   task_id, job_id,
//   required_count, matched_count, missing_count, is_fully_matched,
//   matched_skills: [{ name, matched_to }],
//   missing_skills: [{ name }]
// }
export async function getJobTaskSkills(jobId, taskId) {
  if (jobId == null || jobId === "" || taskId == null || taskId === "") {
    throw new Error("Both jobId and taskId are required");
  }
  const qs = new URLSearchParams({
    job_id: String(jobId),
    task_id: String(taskId),
  }).toString();
  const res = await api.get(`/job-task-skills?${qs}`);
  return normalizeJobTaskSkills(res);
}

function normalizeJobTaskSkills(res) {
  const data = res && typeof res === "object" ? res : {};
  const matched = Array.isArray(data.matched_skills) ? data.matched_skills : [];
  const missing = Array.isArray(data.missing_skills) ? data.missing_skills : [];
  return {
    task_id: data.task_id ?? null,
    job_id: data.job_id ?? null,
    required_count: Number(
      data.required_count ?? matched.length + missing.length,
    ),
    matched_count: Number(data.matched_count ?? matched.length),
    missing_count: Number(data.missing_count ?? missing.length),
    is_fully_matched:
      typeof data.is_fully_matched === "boolean"
        ? data.is_fully_matched
        : missing.length === 0,
    matched_skills: matched.map((s) => ({
      name: s?.name ?? "",
      matched_to: s?.matched_to ?? "",
    })),
    missing_skills: missing.map((s) => ({ name: s?.name ?? "" })),
  };
}
